import React from "react";

const PlayNowIcon = (props) => {
	return (
		<svg
			width="15"
			height="17"
			viewBox="0 0 15 17"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}>
			<path
				d="M13.6757 10.008C13.6003 10.0853 13.3159 10.416 13.0509 10.688C11.4974 12.3987 7.44477 15.1987 5.32363 16.0533C5.0015 16.1907 4.18708 16.4813 3.75194 16.5C3.33499 16.5 2.93752 16.404 2.55824 16.2093C2.08543 15.9373 1.70615 15.5093 1.49832 15.004C1.36453 14.6533 1.1567 13.604 1.1567 13.5853C0.948878 12.4373 0.834572 10.572 0.834573 8.51067C0.834573 6.54667 0.948878 4.75733 1.11904 3.592C1.13852 3.57333 1.34635 2.26933 1.57366 1.82267C1.99061 1.00667 2.80503 0.500001 3.67661 0.500001L3.75194 0.500001C4.31957 0.520002 5.51328 1.02667 5.51328 1.04534C7.52011 1.90134 11.4792 4.564 13.0704 6.33333C13.0704 6.33333 13.5185 6.788 13.7133 7.072C14.0173 7.48 14.168 7.98533 14.168 8.49067C14.168 9.05467 13.9978 9.58 13.6757 10.008Z"
				fill="#EFF0F6"
			/>
		</svg>
	);
};

export default PlayNowIcon;
